import { PlayerWithUnregisteredTimeshift, } from './unregistered';
import { PlayerWithRegisteredTimeshift } from './registered';
export const PlayerWithTimeshift = (Base) => {
    return PlayerWithRegisteredTimeshift(PlayerWithUnregisteredTimeshift(Base));
};
